module.exports = __webpack_public_path__ + "static/flyer-2de91399fbef1a23d4dc582373ed1c3f.pdf";